import React from "react";
import styled from "styled-components";
import {
  ColorBgGray,
  ColorDarkBlack,
  ColorGray,
  ColorLightGray,
  ColorMainBlue,
  ColorWhite,
} from "../../Utiles/Color";
import { Btn, Text } from "../../Assets/css/common";
import ico_close from "../../Assets/images/ico_close_btn.png";

function AgreeModal(props) {
  const { onSubmit } = props;

  return (
    <>
      <ModalBg>
        <ModalWrap>
          <ModalTitle>
            <Text
              weight={"700"}
              align={"center"}
              className="leading-10 text-base md:text-3xl lg:text-4xl"
            >
              CanonERP 공급자 이용약관
            </Text>
            <ClostBtn onClick={onSubmit}>
              <img src={ico_close} alt="close modal" />
            </ClostBtn>
          </ModalTitle>
          <ModalScroll className="mt-5 md:mt-7.5">
            <Text color={ColorGray} className="text-xs md:text-sm">
              제 1 조 (목적) <br />
              이 약관은 캐논코리아㈜(이하 “운영자”라 한다)가 구축하여 운영하고
              있는 CanonERP를 통하여 공급자가 공급업무를 수행함에 있어 필요한
              권리, 의무 및 책임사항을 정함을 목적으로 한다. <br />
              <br />
              제2조 (정의) <br />
              ① “시스템”이란 개별 병원(이하 “발주자”라 한다)이 재화 또는
              용역(이하 “재화 등”이라 한다)을 발주하고, “공급자”가 이를 공급할
              수 있도록 설정한 가상의 영업장을 말한다. <br />
              <br />
              ② “발주자”란 “시스템”을 통하여 “공급자”에게 “재화 등”을 발주하는
              자를 말한다. <br />
              <br />
              ③ “공급자”란 “시스템”을 통하여 “발주자”가 발주한 “재화 등”을
              공급하는 자를 말한다. <br />
              <br />
              제3조 (약관 등의 명시와 설명 및 개정) <br />
              ① “운영자”는 “공급자”가 이 약관의 내용 이해, 확인할 수 있도록
              별도의 연결화면 또는 팝업화면 등을 제공하고, “공급자”가 공급업무를
              위해 이 약관에 동의하는 것으로 그 효력이 발생한다. <br />
              <br />
              ② “운영자”는 「전자상거래 등에서의 소비자보호에 관한 법률」,
              「약관의 규제에 관한 법률」, 「전자문서 및 전자거래기본법」,
              「전자금융거래법」, 「전자서명법」, 「정보통신망 이용촉진 및
              정보보호 등에 관한 법률」, 「방문판매 등에 관한 법률」,
              「소비자기본법」 등 관련 법을 위배하지 않는 범위에서 이 약관을
              개정할 수 있다. <br />
              <br />
              ③ “운영자”가 약관을 개정할 경우에는 적용일자 및 개정사유를
              명시하여 현행 약관과 함께 “시스템”의 초기화면에 그 적용일자 7일
              이전부터 적용일자 전일까지 공지합니다. 다만, “공급자”에게 불리하게
              약관 내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을
              두고 공지합니다. 이 경우 “운영자”는 개정 전 내용과 개정 후 내용을
              명확하게 비교하여 “공급자”가 알기 쉽도록 표시한다. <br />
              <br />
              ④ “운영자”가 약관을 개정할 경우에는 그 개정약관은 그 적용일자
              이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에
              대해서는 개정 전의 약관조항이 그대로 적용된다. 단, 이미 계약을
              체결한 “공급자”가 개정약관 조항의 적용에 대해 본조 제3항에 의한
              개정약관의 공지기간 내에 의 동의한 경우에는 개정약관 조항이
              적용된다. <br />
              <br />
              ⑤ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는
              「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에
              관한 법률」, 공정거래위원회가 정하는 전자상거래 등에서의 소비자
              보호지침 및 관계법령 또는 상관례에 따른다. <br />
              <br />
              제4조 (서비스의 제공 및 변경) <br />
              ① “운영자”는 “시스템”을 통해 다음과 같은 서비스를 제공한다. <br />
              <br />
              1. “발주자”의 발주서 접수 및 수주 내역 확인 <br />
              <br />
              2. “공급자” 납품 예정 수량 전송 <br />
              <br />
              3. 납품 명세서 사본 업로드 및 보관 <br />
              <br />
              ② “시스템”의 기술적 사양의 변경 등이 필요한 경우 서비스 내용이
              변경될 수 있으며, 해당 변경 사항은 “시스템”의 초기화면(공지화면)
              등에 공지한다. <br />
              <br />
              ③ “공급자”의 “시스템” 이용은 “운영사”의 정책에 따라 유료정책으로
              변경될 수 있다. <br />
              <br />
              제5조 (서비스의 중단) <br />
              ① “운영자”는 컴퓨터 등 정보통신설비의 보수점검․ 교체 등의 사유로
              “시스템”의 제공을 일시적으로 중단할 수 있다. <br />
              <br />
              ② “운영자”는 제1항의 사유로 “시스템” 제공이 일시적으로 중단됨에
              따라 “공급자”에게 손해가 발생하는 경우 이를 배상한다. 단,
              “운영자”가 본인의 고의 또는 과실 없음을 입증하거나 사전에 공지한
              교체, 점검 및 보수 등(정기, 수시 등 명칭 불문)의 경우에는 그러하지
              아니하다. <br />
              <br />
              ③ 사업 종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로
              “시스템”을 제공할 수 없게 되는 경우에는 “운영자”는 제8조에 정한
              방법으로 “공급자”에게 통지하여야 한다. <br />
              <br />
              제6조 (공급자 등록 및 중단) <br />
              ① “시스템”을 이용하여 재화 등을 공급하거나, “시스템”에서 제공하는
              정보를 이용하고자 하는 “공급자”에 대하여 “발주자”가 “공급자”로
              등록하거나 권한을 부여한다. <br />
              <br />
              ② “공급자”가 다음 각호에 해당하는 경우 “발주자” 또는 “운영자”가
              “공급자”의 자격을 제한 및 정지시킬 수 있다. <br />
              <br />
              1. “발주자”의 정당한 요청에 따른 재화 등의 공급의무를 이행하지
              않는 경우 <br />
              <br />
              2. 타인의 정보를 도용하는 등 전자상거래 질서를 위협하는 경우{" "}
              <br />
              <br />
              3. “시스템” 이용 관련하여 법령 또는 이 약관이 금지하거나
              공서양속에 반하는 행위를 하는 경우 <br />
              <br />
              제7조 (역할 및 책임) <br />
              ① “공급자”는 “시스템”을 이용하여 “발주자”에게 “재화 등”을
              공급하며, 공급과 관련하여 이 약관, “발주자” 발주내역 및 요청사항,
              “시스템”에 공지된 사항들을 준수하고, 이를 준수하지 않아 발생하는
              불이익, 손해에 대한 책임은 “공급자” 본인에게 있다. <br />
              <br />
              ② “운영자”는 법령과 이 약관에서 금지하거나 공서양속에 반하는
              행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고
              안정적으로 “시스템”과 관련된 서비스를 제공하는데 최선을 다하여야
              한다. <br />
              <br />
              ③ “공급자”가 “시스템”을 통해 "발주자”에게 공급하는 상품의 주문 및
              배송, 환불, 기타 상품 관련 사항 등과 관련한 의무와 책임은 상품을
              공급하는 각 “공급자”에게 있다. <br />
              <br />
              ④ “운영자”가 제공하는 “시스템”을 통한 상품의 공급와 관련하여
              발생하는 주문의 이행, 상품의 배송, 청약철회 또는 반품 등의
              거래진행은 거래의 당사자인 “발주자”와 “공급자” 간에 수행되어야
              합니다. 따라서 “운영자”는 상품의 거래진행에는 전혀 관여하지
              않으며, 거래와 관련된 어떠한 책임도 부담하지 않는다. <br />
              <br />
              ⑤ “공급자”가 “운영자”가 제공하는 “시스템”을 통하지 않고 제3자의
              프로그램을 이용하여 상품 등의 등록, 주문조회, 배송처리 등의 업무를
              하는 경우, 그 과정에서 유발되는 각종 기술적, 법적 문제에 대하여
              “운영자”는 아무런 책임을 지지 아니하며, 이로 인해 발생하는 모든
              손해 및 분쟁에 대해서는 “공급자” 본인에게 책임이 있습니다. <br />
              <br />
              제8조 (시스템 이용 범위) <br />
              “공급자”가 “시스템”에서 이용할 수 있는 서비스의 범위는 다음 각호와
              같다. <br />
              <br />
              1. 발주 정보의 입수 및 발주 참가 <br />
              <br />
              2. 발주 및 공급 목록 조회 <br />
              <br />
              3. 공급 예정 정보 변경 및 추가 <br />
              <br />
              4. 납품명세서 등록 및 관리 <br />
              <br />
              제9조 (공급자에 대한 통지) <br />
              “운영자”가 “공급자”에 대해 통지하는 경우 1주일 이상
              초기화면(공지화면)에 게시함으로써 개별 통지에 갈음할 수 있다.
              다만, 각각의 “공급자”에 중대한 영향을 미치는 사항의 경우
              개별적으로 통지 한다. <br />
              <br />
              제10조 (계약의 성립) <br />
              시스템”에서 “발주자”가 “재화 등”을 발주하고 “공급자”가 발주를
              승낙하여, 해당 승낙이 “발주자”에게 도달한 시점에 계약이 성립한
              것으로 본다. “공급자”의 승낙의 의사표시에는 “발주자”의 발주에 대한
              확인 및 공급 가능여부, 수량의 정정, 변경 등에 관한 정보 등을
              포함하여야 한다. <br />
              <br />
              제11조 (재화 등의 공급) <br />
              ① “공급자”는 “발주자”와 재화 등의 공급시기에 관하여 별도의 약정이
              없는 이상, 제10조에 따른 계약의 성립일로부터 발주자가 지정한
              납기일자 이내에 재화 등을 배송하며, “공급자”는 “발주자”가 재화
              등의 공급 절차 및 진행 사항을 확인할 수 있도록 “시스템”에 공급
              관련사항을 지체없이 등록한다. <br />
              <br />
              ② “공급자”는 제10조에 따라 계약이 성립한 후 “발주자”가 발주한 재화
              등의 수량 부족한 경우, “발주자”와 협의하여 발주 수량 중 일부만을
              공급할 수 있다. <br />
              <br />
              ③ “공급자”는 제10조에 따라 계약이 성립한 후 “발주자”가 발주한 재화
              등이 품절 등의 사유로 공급할 수 없는 경우 지체없이 그 사유를
              “발주자”에게 통지한다. <br />
              <br />
              제12조 (공급자의 의무) <br />
              ① “공급자”는 다음 각호의 행위를 하여서는 안된다. <br />
              <br />
              1. 공급 관련 허위 내용의 등록 <br />
              <br />
              2. 타 업체의 정보 도용 <br />
              <br />
              3. “시스템”에서 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의
              송신 또는 게시 <br />
              <br />
              4. 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위 <br />
              <br />
              ② “공급자”는 “시스템”을 통해 재화 등의 확인, 승낙, 재화 등을
              공급하기 위하여 다음 각호의 정보를 "공급자” 및 “발주자”에게
              제공한다. <br />
              <br />
              1. 납품 예정 품목 및 수량(“발주자”의 발주 정보와 납품 정보 오차
              확인 목적) <br />
              <br />
              2. 납품명세서 사본(납품 완료 후 납품증빙 목적) <br />
              <br />
              제13조 (지식재산권의 귀속 및 이용제한) <br />
              ① “운영자”가 작성한 지식재산권에 대한 지식재산권은 “운영자”에
              귀속한다. <br />
              <br />
              ② “공급자”는 “시스템”을 이용함으로 얻은 정보 중 “운영자”에게
              지식재산권이 귀속된 정보를 “운영자”의 사전 승낙 없이 복제, 송신,
              출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나
              제3자에게 이용하게 하여선 안된다. <br />
              <br />
              제14조 (분쟁해결 및 재판권) <br />
              ① 이 약관의 해석에 관한 분쟁은 당사자간 협의로 해결하며, 협의로
              해결되지 않는 경우 소송으로 해결하고, 그 재판관할은 민사소송법의
              규정에 따른다. <br />
              <br />② “운영자”와 "공급자” 간에 제기된 소송에는 대한민국법을
              적용한다.
            </Text>
          </ModalScroll>
        </ModalWrap>
      </ModalBg>
    </>
  );
}

const ModalBg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
`;
const ModalWrap = styled.div`
  position: relative;
  display: block;
  width: 96%;
  max-width: 744px;
  height: 80vh;
  padding: 40px;
  border-radius: 10px;
  background-color: ${ColorBgGray};

  @media all and (max-width: 767px) {
    width: 100%;
    height: 100%;
    padding: 0 16px 20px;
    border-radius: 0;
  }
`;
const ModalTitle = styled.div`
  p {
    color: ${ColorMainBlue};
  }

  @media all and (max-width: 767px) {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;

    p {
      color: ${ColorDarkBlack};
    }
  }
`;
const ClostBtn = styled(Btn)`
  position: absolute;
  top: 15px;
  right: 15px;

  img {
    width: 24px;
  }

  @media all and (max-width: 767px) {
    top: calc(50% - 20px);
    right: -8px;
    padding: 8px;
  }
`;
const ModalScroll = styled.div`
  height: calc(100% - 70px);
  padding: 14px 12px;
  border: 1px solid ${ColorLightGray};
  border-radius: 6px;
  background-color: ${ColorWhite};
  overflow-y: auto;
`;

export default AgreeModal;
